// This is a 1:1 port from FDS's ToggleButton component
// All modifications are only to make it work with the current project
// When we introduce FDS, delete this file and associated CSS (in src/css/ShareDBDocTimeline.scss)
import React, { useState } from 'react';

function useControllable(controlledValue, initialValue, changeHandler = null) {
  const [uncontrolledValue, setUncontrolledValue] = useState(initialValue);
  const effectiveValue =
    controlledValue !== undefined ? controlledValue : uncontrolledValue;
  return [effectiveValue, setValue];

  function setValue(newValue, event) {
    setUncontrolledValue(newValue);
    if (changeHandler) changeHandler(newValue, event);
  }
}

export const ToggleButton = (props) => {
  const {
    className,
    value: controlledValue,
    initialValue = false,
    onChange,
  } = props;

  const [value, setValue] = useControllable(
    controlledValue,
    initialValue,
    onChange
  );

  return (
    <div className={className}>
      <label
        className={value ? 'toggle-button active' : 'toggle-button'}
        onChange={(event) => setValue(!value, event)}
        htmlFor="timeline-toggle"
      >
        <input
          id="timeline-toggle"
          name="timeline-toggle"
          type="checkbox"
          className="display-none"
        />
      </label>
    </div>
  );
};
